export const ALLOWED_COMPANY_STATUS_LOGIN = [
  'ACTIVE',
  'REGISTERED',
];

export const AUTH_FLOW_TYPE = 'USER_SRP_AUTH';

export const AUTH_STATUS = {
  LOADING: 'LOADING',
  AUTHENTICATED: 'AUTHENTICATED',
  NOT_AUTHENTICATED: 'NOT_AUTHENTICATED'
};

export const COMPANY_KSUID_STORAGE_KEY = 'currentCompany';

// Account that had just been added to a company
// will be listed as REGISTERED. Once the account is activated,
// it becomes ACTIVE
export const COMPANY_ENROLLMENT_STATUS_NEED_ACTIVATION = 'REGISTERED';

export const DEFAULT_MAX_LOGIN_RETRIES = 5;
export const DEFAULT_MAX_VALIDATE_LOGIN_RETRIES = 5;
export const DEFAULT_RETRY_ATTEMPT_MINIMUM_TIMEOUT = 1000; // 1s
export const DEFAULT_SIGN_UP_ATTRIBUTES = {
  'custom:account_type': 'company',
  'custom:is_tms': 'tms',
};

// https://kargox.atlassian.net/l/c/Hc08Tx1N
export const LOGIN_STATUS_MAP = {
  UNITIALIZED: -1,
  SUCCESs_WITHOUT_WARNING: 0,
  SUCCESS_AS_FIRST_TIME_LOGIN: 1,
  FAILED_DEACTIVATED_FROM_COMPANIES: 2,
  FAILED_TIMEOUT: 3
};

export const TRANSLATIONS_NAMESPACE = 'auth';

export default {};
